<template>
  <div>
    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
      <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="filteredItems()"
          worksheet="Analisis Cartera"
          name="analisis-cartera.xls"
          :fields="json_fields"
          >Exportar</downloadExcel
        >
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha abono desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_task_management.startDate"
            :max="
              range_task_management.endDate == ''
                ? maxDate
                : range_task_management.endDate
            "
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha abono hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_task_management.endDate"
            :min="range_task_management.startDate"
            :max="maxDate"
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0" for="cmbCuenta">Cuenta</label>
          <b-form-select
            v-model="customer_id_filter"
            id="cmbCuenta"
            @change="changeCustomer()"
          >
            <template slot="first">
              <option :value="null">
                -- Por favor seleccione una opción --
              </option>
            </template>

            <option
              v-for="item in lstCustomers"
              :key="item.id"
              :value="item.id"
            >
              {{ item.business_name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Orden de servicio</label>
          <b-form-select
            v-model="service_order_id_filter"
            @change="getDebtors()"
            :disabled="customer_id_filter == null"
          >
            <template slot="first">
              <option :value="null">-- Orden de servicio --</option>
            </template>
            <option
              v-for="item in lstServiceOrder"
              :key="item.id"
              :value="item.id"
            >
              CONTRATO_{{ item.agreement_number }} - ORDEN_{{ item.number }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group>
          <label class="mb-0">Tipificación</label>
          <b-form-select v-model="type_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Tipificación --</option>
            </template>
            <option v-for="item in lstType" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 8">
        <b-form-group>
          <label class="mb-0">Cobrador / Abogado</label>
          <b-form-select v-model="staff_id_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Responsable--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label for="cmbEstado" class="mb-0">Estado</label>
          <b-form-select
            v-model="status_filter"
            id="cmbEstado"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Todos --</option>
            </template>
            <option value="P">Pausado</option>
            <option value="A">Activo</option>
            <option value="C">Cerrado</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbEtapa" class="mb-0">Etapa de cobro</label>
          <b-form-select
            v-model="process_id_filter"
            id="cmbEtapa"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Etapa de cobro --</option>
            </template>
            <option v-for="item in lstProcess" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

    </b-row>

    <b-row>

      <b-col sm="3" v-if="isAdmin">
        <b-form-group>
          <label for="cmbStaff" class="mb-0">Comercial</label>
          <b-form-select
            v-model="customer_staff_id_filter"
            id="cmbStaff"
            @change="getDebtors()"
          >
            <template slot="first">
              <option :value="null">-- Comercial --</option>
            </template>
            <option
              v-for="item in lstComercialStaffs"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="card-group mb-4">
      <div class="card card-accent-primary">
        <div class="card-body">
          <!-- <div class="text-value">
            $ {{ formatPrice(summary.capital_recover) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >CAPITAL INICIAL</small
          >
          <hr /> -->
          <div class="text-value">
            $ {{ formatPrice(summary.capital_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >CAPITAL COBRADO</small
          >
          <!-- <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.capital_by_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >CAPITAL POR COBRAR</small
          > -->
        </div>
      </div>

      <div class="card card-accent-warning">
        <div class="card-body">
          <!-- <div class="text-value">
            $ {{ formatPrice(summary.total_interests) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >INTERÉS INICIAL</small
          >
          <hr /> -->
          <div class="text-value">
            $ {{ formatPrice(summary.interests_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >INTERÉS RECUPERADO</small
          >
          <!-- <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.interests_by_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >INTERÉS POR RECUPERAR</small
          > -->
        </div>
      </div>

      <div class="card card-accent-info">
        <div class="card-body">
          <!-- <div class="text-value">$ {{ formatPrice(summary.total_fees) }}</div>
          <small class="text-muted text-uppercase font-weight-bold"
            >HONORARIOS INICIALES</small
          >
          <hr /> -->
          <div class="text-value">
            $ {{ formatPrice(summary.fees_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >HONORARIOS COBRADOS</small
          >
          <!-- <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.fees_by_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >HONORARIOS POR COBRAR</small
          > -->
        </div>
      </div>
    </div>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div v-if="isAdmin">
              <div class="row" v-if="selectItems.length > 0">
                <div class="col-sm-2">
                  <downloadExcel
                    class="btn btn-warning col-sm-12 mb-2"
                    :data="selectItems"
                    worksheet="Indicadores"
                    name="indicators.xls"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                    >Exportar</downloadExcel
                  >
                </div>
              </div>
            </div>

            <div>
              <b-table
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                :items="filteredItems()"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template slot="HEAD_selected" v-if="isAdmin">
                  <input
                    type="checkbox"
                    @click.stop
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </template>

                <template slot="selected" slot-scope="data" v-if="isAdmin">
                  <input
                    type="checkbox"
                    v-model="data.item.selected"
                    @change="selectRow(data.item)"
                  />
                </template>

                <template slot="created_at" slot-scope="data">{{
                  formatDateDescriotion(data.item.created_at)
                }}</template>

                <template
                  slot="commitments"
                  slot-scope="data"
                  class="text-center"
                  >{{ data.item.commitments }}</template
                >

                <template slot="capital_recover" slot-scope="data"
                  >${{ formatPrice(data.item.capital_recover) }}</template
                >

                <template slot="capital" slot-scope="data"
                  >${{ formatPrice(data.item.capital) }}</template
                >

                <template slot="initial_payments" slot-scope="data"
                  >${{ formatPrice(data.item.initial_payments) }}</template
                >

                <template slot="capital_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.capital_recovered) }}</template
                >

                <template slot="capital_by_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.capital_by_recovered) }}</template
                >

                <template slot="interest" slot-scope="data"
                  >${{ formatPrice(data.item.interest) }}</template
                >

                <template slot="interests_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.interests_recovered) }}</template
                >

                <template slot="interests_by_recovered" slot-scope="data"
                  >${{
                    formatPrice(data.item.interests_by_recovered)
                  }}</template
                >

                <template slot="fee" slot-scope="data"
                  >${{ formatPrice(data.item.fee) }}</template
                >

                <template slot="fees_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.fees_recovered) }}</template
                >

                <template slot="fees_by_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.fees_by_recovered) }}</template
                >

                <template slot="total_recovered" slot-scope="data"
                  >${{ formatPrice(data.item.total_recovered) }}</template
                >

                <!-- <template v-slot:cell(actions)="data">-->
                <template slot="actions" slot-scope="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1 btn-custom-size"
                    @click="viewDebtor(data.item.id)"
                    title="Gestionar"
                    :disabled="data.item.owner == 0"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  getRowCount(items) > perPage * currentPage
                    ? perPage * currentPage
                    : getRowCount(items)
                }}
                de {{ getRowCount(items) }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "PaymentsAnalysis",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "ANÁLISIS DE ABONOS",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,

      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created_at: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        // startDate: moment(String(new Date("2009", "12", "01"))).format(
        //   "YYYY-MM-DD"
        // ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },

      range_task_management: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },

      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        { key: "customer_business_name", label: "Cliente", sortable: true },
        { key: "business_name", label: "Deudor", sortable: true },
        { key: "commitments", label: "# Acuerdos", sortable: true },
        { key: "capital_recover", label: "Capital entregado", sortable: true },
        // { key: "capital", label: "Capital total", sortable: true },
        // { key: "initial_payments", label: "Abonos previos", sortable: true },
        { key: "capital_recovered", label: "Abonos a capital", sortable: true },
        {
          key: "capital_by_recovered",
          label: "Capital por cobrar",
          sortable: true,
        },
        { key: "interest", label: "Total intereses", sortable: true },
        {
          key: "interests_recovered",
          label: "Abonos a intereses",
          sortable: true,
        },
        {
          key: "interests_by_recovered",
          label: "Intereses por cobrar",
          sortable: true,
        },
        { key: "fee", label: "Total honorarios", sortable: true },
        { key: "fees_recovered", label: "Honorarios cobrados", sortable: true },
        {
          key: "fees_by_recovered",
          label: "Honorarios por cobrar",
          sortable: true,
        },

        { key: "total_recovered", label: "Total recuperado", sortable: true },

        { key: "actions", label: "Opciones" },
      ],

      json_fields: {
        Cliente: "customer_business_name",
        Deudor: "business_name",
        "# Acuerdos": "commitments",

        "Capital entregado": {
          field: "capital_recover",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        // "Capital total": {
        //   field: "capital",
        //   callback: value => {
        //     return `$ ${GformatPrice(value)}`;
        //   }
        // },

        // "Abonos previos": {
        //   field: "initial_payments",
        //   callback: value => {
        //     return `$ ${GformatPrice(value)}`;
        //   }
        // },

        "Abonos a capital": {
          field: "capital_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Capital por cobrar": {
          field: "capital_by_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Total intereses": {
          field: "interest",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Abonos a intereses": {
          field: "interests_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Intereses por cobrar": {
          field: "interests_by_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Total honorarios": {
          field: "fee",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Honorarios cobrados": {
          field: "fees_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Honorarios por cobrar": {
          field: "fees_by_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },

        "Total recuperado": {
          field: "total_recovered",
          callback: (value) => {
            return `$ ${GformatPrice(value)}`;
          },
        },
      },

      status: null,
      items: [],
      pagination: {},
      filter: null,
      tableData: [],
      tableHeader: [],
      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      //
      selectItems: [],
      selectAll: false,
      // FILTROS DE BUSQUEDA
      customer_debtor_identification_filter: null,
      service_order_id_filter: null,
      created_at_filter: null,
      status_filter: "A",
      type_filter: null,
      staff_id_filter: null,
      type_task_management: null,
      customer_id_filter: null,
      process_id_filter: null,
      customer_staff_id_filter: null,

      // LISTAS PARA LOS FILTROS
      lstServiceOrder: [],
      lstStaffs: [],
      lstComercialStaffs: [],
      lstType: [],
      lstCustomers: [],
      lstProcess: [],
      summary: {
        total_debt: 0,
        capital_recovered: 0,
        capital_recover: 0,
        capital_by_recovered: 0,
        total_agreements: 0,
        interests_recovered: 0,
        total_interests: 0,
        interests_by_recovered: 0,
        fees_recovered: 0,
        total_fees: 0,
        fees_customer: 0,
        fees_by_recovered: 0,
      },

      // PAGINACIÓN DE VUE
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  mounted() {
    this.initParameters();
    this.getDebtors();
  },
  computed: {},
  methods: {
    initParameters() {
      // var auth = localStorage.getItem("auth");
      // auth = JSON.parse(auth);
      // this.isCustomer = authAux[0].customer_id != null ? true : false;

      // LISTA DE CUENTAS
      var auth = localStorage.getItem("auth");
      let authAux = JSON.parse(auth);
      this.isCustomer = authAux[0].customer_id != null ? true : false;
      this.staff_id_filter =
        this.role_id == 1 || this.role_id == 8 ? null : authAux[0].staff_id;

      let url = `${this.$urlApi}customers/staff?token=${this.token}`;

      // if (authAux[0].is_admin === "N") {
      //   authAux[0].filter_staff_id = authAux[0].staff_id;
      // }
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          (response) => {
            console.log(response);
            this.lstCustomers = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );

      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
          // console.log(response.data.data);
        },
        (error) => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // TIPIFICACIÓN DEUDOR
      this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // PROCESOS
      this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
        (response) => {
          this.lstProcess = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = [];
      return keys;

      if (this.items[0] === undefined) return null;
      else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },

    changeDateImport() {
      if (
        this.range_created_at.startDate != "" &&
        this.range_created_at.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },
    changeDateTask() {
      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.endDate != ""
      ) {
        this.getDebtors();
      } else return;
    },

    getDebtors: function (urlPage) {
      let authAux = JSON.parse(this.auth);
      authAux[0].customer_debtor_identification =
        this.customer_debtor_identification_filter;
      authAux[0].service_order_id = this.service_order_id_filter;
      authAux[0].status = this.status_filter;
      authAux[0].type = this.type_filter;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].process_id = this.process_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].image = null;

      if (this.customer_id_filter) {
        authAux[0].customer_id = this.customer_id_filter;
      }

      authAux[0].type_task_management = this.type_task_management;
      authAux[0].start_date_created_at = moment(
        this.range_created_at.startDate
      ).format("YYYY-MM-DD");
      authAux[0].end_date_created_at = moment(
        this.range_created_at.endDate
      ).format("YYYY-MM-DD");

      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.endDate != ""
      ) {
        authAux[0].start_date_task_management = moment(
          this.range_task_management.startDate
        ).format("YYYY-MM-DD");
        authAux[0].end_date_task_management = moment(
          this.range_task_management.endDate
        ).format("YYYY-MM-DD");
      }

      let url = `${this.$urlApi}debtors/indicators/payments?token=${this.token}`;
      showLoader();
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            // console.clear();
            console.log(response);
            this.items = response.data.data;
            this.summary = response.data.summary;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    deleteDebtor(item) {
      if (!this.isAdmin && item.status === "A") {
        this.$swal({
          title: "Advertencia",
          text: "El deudor no se puede eliminar, porque se encuenra activo!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return false;
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el registro!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}debtors/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Registro eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getDebtors();
                }
              });
            })
            .catch((error) => {
              console.log(error.body.error);
              alert(error.body.error);
              hideLoader();
            });
        }
      });
    },
    editDebtor(item) {
      if (this.isCustomer && item.status == "A") {
        this.$swal({
          title: "Advertencia",
          text: "El resgitro no se puede editar, ya se encuentra activo!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return false;
      }

      let url = `${location.origin}/#/debtors/edit/${id.toString()}`;
      window.open(url, "_blank");
    },
    viewDebtor(id) {
      let url = `${location.origin}/#/debtors/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    formatDateDescriotion(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },
    changeCustomer() {
      if (
        this.customer_id_filter != null &&
        this.customer_id_filter != "null" &&
        this.customer_id_filter != undefined
      ) {
        // ORDENES DE SERVICIO
        this.getDebtors();
        this.$http
          .get(
            `${this.$urlApi}serviceorders/customer/${this.customer_id_filter}?token=${this.token}`
          )
          .then(
            (response) => {
              this.lstServiceOrder = response.body.data;
              // hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      }
    },
  },
};
</script>
